import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { range } from 'utils/helpers';

import styles from './MultipleStarRating.css';
import SingleStar from './SingleStar';


export const STAR_FILL_OPTIONS = {
  EMPTY: 'empty',
  FULL: 'full',
};

const MultipleStarRating = ({
  containerClassName,
  filledStarProps,
  emptyStarProps,
  numberOfStars = 5,
  onStarClick,
}) => {
  const [currentRating, setCurrentRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);

  const onHover = useCallback(
    (_, index) => {
      setHoveredRating(index);
    },
    [setHoveredRating]
  );

  const onLeave = useCallback(() => setHoveredRating(0), [setHoveredRating]);

  const onClick = useCallback(
    (_, index) => {
      setCurrentRating(index);
      onStarClick(index);
    },
    [setCurrentRating, onStarClick]
  );

  const getFillingAmmountForStar = useCallback(
    (index) => {
      const rating = hoveredRating || currentRating;

      if (index <= rating) {
        return STAR_FILL_OPTIONS.FULL;
      }

      return STAR_FILL_OPTIONS.EMPTY;
    },
    [hoveredRating, currentRating]
  );

  return (
    <div className={classNames(containerClassName, styles.container)}>
      {range(1, numberOfStars + 1).map((i) => (
        <SingleStar
          key={i}
          ammountFilled={getFillingAmmountForStar(i)}
          emptyStarProps={emptyStarProps}
          filledStarProps={filledStarProps}
          index={i}
          onClick={onClick}
          onMouseEnter={onHover}
          onMouseLeave={onLeave}
        />
      ))}
    </div>
  );
};

MultipleStarRating.defaultProps = {
  containerClassName: null,
  emptyStarProps: {},
  filledStarProps: {},
  numberOfStars: 5,
  onStarClick: () => undefined,
};

MultipleStarRating.propTypes = {
  containerClassName: PropTypes.string,
  emptyStarProps: PropTypes.object,
  filledStarProps: PropTypes.object,
  numberOfStars: PropTypes.number,
  onStarClick: PropTypes.func,
};

export default MultipleStarRating;
